export interface ExchangeCondition {
  id?: string;
  name: string;
  referenceDate: string;
  days: number;
  direction: string; // "Depois" | "Antes"
}

// Datas do processo que podem servir de base para o cálculo do câmbio.
// O "value" é exatamente o nome do campo no formulário do processo.
export const referenceDateOptions: { value: string; label: string }[] = [
  { value: "openingDate", label: "Data de abertura" },
  { value: "shippingDate", label: "Data de embarque" },
  { value: "arrivalDate", label: "Data de chegada" },
  { value: "registrationDate", label: "Data de registro" },
  { value: "customsClearanceDate", label: "Data do desembaraço" },
  { value: "nfIssued", label: "Data de emissão da NF" },
  { value: "validity", label: "Validade" },
  { value: "statusDate", label: "Data do status" },
];

export const directionOptions = ["Depois", "Antes"];

export const referenceDateLabel = (value?: string) =>
  referenceDateOptions.find((o) => o.value === value)?.label ?? value ?? "";

export const describeCondition = (c: ExchangeCondition) =>
  `${c.days} dia(s) ${(c.direction || "Depois").toLowerCase()} de ${referenceDateLabel(
    c.referenceDate
  )}`;
